import { ref } from 'vue';
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.component('page-loader', Component);

    const active = ref(false);
    const progress = ref(0);
    const text = ref('Something very important is happening!');

    const show = (message) => {
      if (message) {
        text.value = message;
      }

      active.value = true;
    }

    const hide = () => {
      active.value = false;
    }

    const toggle = () => {
      active.value = !active.value;
    }

    const updateText = value => {
      text.value = value;
    }

    const updateProgress = value => {
      progress.value = value;
    }

    const pageLoader = { active, show, hide, toggle, text, progress, updateText, updateProgress };

    app.config.globalProperties.$pageLoader = pageLoader;
    app.provide('$pageLoader', pageLoader);
  }
}